import axios from 'axios';
import { BASE_URL } from '../api/config';

export interface VariableDispo {
  cle: string;
  desc?: string;
  exemple?: any;
}

export interface EmailTemplate {
  id: number;
  code: string;
  libelle: string;
  categorie: string | null;
  declencheur: string | null;
  destinataire_type: string | null;
  backend: 'admin' | 'client';
  sujet: string;
  corps_html: string;
  variables_dispo: VariableDispo[] | string | null;
  actif: number;
  date_maj?: string;
  maj_par?: string | null;
}

// Liste de tous les templates (pour le menu)
export const listerEmailTemplates = async (): Promise<EmailTemplate[]> => {
  const res = await axios.get<EmailTemplate[]>(`${BASE_URL}/email-templates`);
  return res.data;
};

// Détail d'un template
export const getEmailTemplate = async (code: string): Promise<EmailTemplate> => {
  const res = await axios.get<EmailTemplate>(`${BASE_URL}/email-templates/${code}`);
  return res.data;
};

// Mise à jour (sujet / corps / actif)
export const majEmailTemplate = async (
  code: string,
  data: { sujet?: string; corps_html?: string; actif?: boolean; maj_par?: string }
): Promise<void> => {
  await axios.put(`${BASE_URL}/email-templates/${code}`, data);
};

// Prévisualisation : renvoie le sujet + le HTML interpolés avec des données d'exemple
export const previewEmailTemplate = async (
  code: string,
  data: { sujet: string; corps_html: string; context?: Record<string, any> }
): Promise<{ sujet: string; html: string; context: Record<string, any> }> => {
  const res = await axios.post(`${BASE_URL}/email-templates/${code}/preview`, data);
  return res.data;
};

// Envoi d'un mail de test
export const envoyerTestEmailTemplate = async (
  code: string,
  data: { email: string; sujet: string; corps_html: string; context?: Record<string, any> }
): Promise<void> => {
  await axios.post(`${BASE_URL}/email-templates/${code}/test`, data);
};

// Normalise variables_dispo (peut arriver en JSON string selon le driver)
export const parseVariables = (v: EmailTemplate['variables_dispo']): VariableDispo[] => {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  try {
    const parsed = JSON.parse(v);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
